import React from "react";

import { Box, BoxProps } from "@mui/material";

export const ShadowCard: React.FC<BoxProps> = ({ ...props }) => {
  return (
    <Box boxShadow="0 4px 8px rgba(0, 0, 0, 0.05)" {...props}>
      {props.children}
    </Box>
  );
};
